import { StrictMode } from 'react';
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

import { Auth0Provider } from '@auth0/auth0-react';

const domain = import.meta.env.VITE_AUTH0_DOMAIN;
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
// Optional: API audience (Auth0 API Identifier). Can be left undefined.
const audience = import.meta.env.VITE_AUTH0_AUDIENCE as string | undefined;

createRoot(document.getElementById("root")!).render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    authorizationParams={{
      redirect_uri: window.location.origin + '/login',
      // Request OIDC identity + refresh token so the SDK can renew silently
      scope: 'openid profile email offline_access',
      // Optional: if you later configure an API in Auth0, set VITE_AUTH0_AUDIENCE
      // and this will be included automatically. Safe to ship as-is.
      ...(import.meta.env.VITE_AUTH0_AUDIENCE
        ? { audience: import.meta.env.VITE_AUTH0_AUDIENCE as string }
        : {})
    }}
    cacheLocation="localstorage"
    useRefreshTokens={true}
  >
    <App />
  </Auth0Provider>
);
